import { graphql } from "@opensea/graphql"

export const TransferFlowDone_itemFragment = graphql(`
  fragment TransferFlowDone_item on Item {
    chain {
      identifier
    }
    contractAddress
    tokenId
    imageUrl
  }
`)
